import { createSlice } from "@reduxjs/toolkit";
const DEFAULT_PAGINATION = { pageIndex: 0, pageSize: 10 };
const initialState = {
    pagination: {
        "knowledge-bases": DEFAULT_PAGINATION,
        chatbots: DEFAULT_PAGINATION,
        users: DEFAULT_PAGINATION,
        "settings/api-keys": DEFAULT_PAGINATION,
        voicebots: DEFAULT_PAGINATION,
        "admin/customer-branches": DEFAULT_PAGINATION,
        "admin/voicebot-phone-nos": DEFAULT_PAGINATION,
        "answer-reviews": DEFAULT_PAGINATION,
        calls: DEFAULT_PAGINATION,
        followups: DEFAULT_PAGINATION,
        "api-tools": DEFAULT_PAGINATION,
        costs: DEFAULT_PAGINATION,
        "accounting-transactions": { pageIndex: 0, pageSize: 50 },
    },
};
const metaListSlice = createSlice({
    name: "metaList",
    initialState,
    reducers: {
        setPagination(state, { payload }) {
            state.pagination[payload.key] = payload.pagination;
        },
    },
});
export const { setPagination } = metaListSlice.actions;
export const paginationSelector = (key) => (state) => state.metalist.pagination[key] || DEFAULT_PAGINATION;
export default metaListSlice.reducer;
